import { useOutletContext } from "@remix-run/react";
import { CardList } from "~/shared";
import type { IMedia } from "~/types";
import { FullbackScreen } from "~/shared";

export default function ProfessionalArticleIndex() {
  const { data } = useOutletContext<{
    data: Array<IMedia>;
    showPendingSpinner: boolean;
    isFetchingNextPage: boolean;
    hasNextPage: boolean;
  }>();

  if ((data && !data.length) || !data)
    return (
      <FullbackScreen
        subtitle="Versuche es mit einem anderen Suchbegriff. Weitere Fachartikel werden in Kürze verfügbar sein."
        title="Leider konnten wir keinen Fachartikel finden."
      />
    );
  // console.log("ProfessionalArticleIndex data", data);
  return <CardList cards={data} routePrefix="/professional_article/main" />;
}
